import {
  CreateAbtestPreviewExtension,
  DefaultChatEventExtensions,
  DefaultChatToolExtensions,
  EscalateToSupportToolExtension,
  UpdateAbtestPreviewExtension,
} from '@spotify/plugin-confidence-chat';
import { CodeBlockExtensions } from '@spotify/plugin-confidence-chat-react';
import { EvidenceCodeBlockExtension } from '@spotify/plugin-confidence-issues';
import {
  RecordingToolExtension,
  RecordingsCodeBlockExtension,
} from '@spotify/plugin-confidence-recordings';

export const DefaultCodeBlockExtensions = () => (
  <CodeBlockExtensions>
    <RecordingsCodeBlockExtension />
    <EvidenceCodeBlockExtension />
  </CodeBlockExtensions>
);

export const DefaultChatExtensions = () => (
  <>
    <DefaultChatEventExtensions />
    <DefaultChatToolExtensions
      toolExtensions={
        <>
          <EscalateToSupportToolExtension />
          <RecordingToolExtension />
        </>
      }
      previewExtensions={
        <>
          <UpdateAbtestPreviewExtension />
          <CreateAbtestPreviewExtension />
        </>
      }
    />
    <DefaultCodeBlockExtensions />
  </>
);
